import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    input,
    linkedSignal,
    ViewChild,
} from '@angular/core';
import { gsap } from 'gsap';
import { Product } from '../../product/product.component';
import { DOMHandlerService } from '../../../../services/domhandler.service';
import { LanguageService } from '../../../../services/language.service';
import { RouterLink } from '@angular/router';
import { CustomPricePipe } from '../../../../pipes/price.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { Image } from '../../../apartment/header/header.component';
import { UmamiService } from '../../../../services/umami.service';

@Component({
    selector: 'app-categories',
    imports: [NgClass, RouterLink, CustomPricePipe, TranslatePipe],
    host: {
        class: '~p-8/12 flex flex-col ~gap-2/4 lg:max-h-[75vh] relative top-[12%] lg:top-[6%]',
    },
    templateUrl: './categories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesComponent {
    categories = input.required<Category[]>();
    domHandler = inject(DOMHandlerService);
    languageService = inject(LanguageService);
    umami = inject(UmamiService);
    selectedCategory = linkedSignal(() => {
        return this.categories()[0];
    });
    @ViewChild('categoryContainer') set categoryItemsRef(value: ElementRef) {
        if (value) {
            value.nativeElement
                .querySelectorAll('.category-item-wrapper')
                .forEach((item: Element, index: number) => {
                    gsap.to(item, {
                        x: 0,
                        opacity: 1,
                        duration: 1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: item,
                            start: `top bottom-=${index * (this.domHandler.isMobile ? 50 : 100)}px`,
                            end: `bottom ${this.domHandler.isMobile ? 'bottom+=100px' : 'top'}`,
                            scrub: 0.5,
                        },
                    });
                });
        }
    }
    @ViewChild('productContainer') set productItemsRef(value: ElementRef) {
        if (value) {
            value.nativeElement
                .querySelectorAll('.product-image')
                .forEach((item: Element, index: number) => {
                    gsap.from(item, {
                        duration: 0.5,
                        y: 100,
                        opacity: 0,
                        ease: 'power2.out',
                        delay: index * 0.1,
                    });
                });

            value.nativeElement.query;
        }
    }
}

export type Category = {
    documentId: string;
    name: string;
    slug: string;
    products: Product[];
    image: Image;
};
